export default __webpack_public_path__ + "static/media/StatusCallFill.ef8ff035.svg";